import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import { DescriptionContainer } from './mergeModal.styles';

type Props = {
  children: string;
};

const Description = ({ children }: Props) => (
  <DescriptionContainer>
    <Text14 themeColor={ThemeColorType.gray}>{children}</Text14>
  </DescriptionContainer>
);

export default Description;
